import { Select } from '@arcadiapower/shrike';
import styled from 'styled-components';
import { space, SpaceProps } from 'styled-system';

export interface StyledSelectProps extends SpaceProps {}

export const StyledSelect = styled(Select)<StyledSelectProps>`
  ${space}

  label {
    font-family: ${props => props.theme.fontFamilies.main.medium};
  }

  max-width: 480px;

  ${props => props.theme.media.largeScreenUp} {
    max-width: 600px;
  }
`;
